const validators = {
    required: () => {
        const fn = val => val !== '' && val !== undefined && val !== null;
        fn.message = 'Value is required.';
        return fn;
    },
    approver: () => {
        const fn = val =>
            val !== '' &&
            (val !== undefined) & (val !== null) & (val !== 'null');
        fn.message = 'Value is required.';
        return fn;
    },
    checkbox: () => {
        const fn = val => {
            return val && val.length > 0;
        };
        fn.message = 'Value is required.';
        return fn;
    },
    select: () => {
        const fn = val => {
            return val && (val.length > 0) & (val !== null) & (val[0] !== 'n');
        };
        fn.message = 'Value is required.';
        return fn;
    },
    maxLength: len => {
        const fn = val => val && val.length <= len;
        fn.message = 'Length is too long. Max: ' + len;
        return fn;
    },
    multiSelectVal: () => {
        const fn = val => {
            return val && val.length > 0;
        };
        fn.message = 'Value is required.';
        return fn;
    },
    empty: () => {
        const fn = val => {
            return (
                val &&
                val !== null &&
                val !== '' &&
                val !== [] &&
                val !== 'null' &&
                val !== '[ ]'
            );
        };
        fn.message = 'Value is required.';
        return fn;
    },
    trimVal: () => {
        const fn = val => {
            if (typeof val === 'string') {
                val = val.trim();
            }
            return (
                val &&
                val !== null &&
                val !== '' &&
                val !== [] &&
                val !== 'null'
            );
        };
        fn.message = 'Value is required.';
        return fn;
    },
    noTrim: () => {
        const fn = val => {
            return (
                val &&
                val !== null &&
                val !== '' &&
                val !== [] &&
                val !== 'null'
            );
        };
        fn.message = 'Value is required.';
        return fn;
    },
    onSite: dateLength => {
        const fn = val => {
            return dateLength > 0;
        };
        fn.message = 'You must add at least 1 on site date';
        return fn;
    },
    disabled: () => {
        const fn = val => {
            if (typeof val === 'string') {
                val = val.trim();
            }
            return val !== ' ';
        };
        fn.message = 'asdf';
        return fn;
    }
};

export default validators;



// WEBPACK FOOTER //
// ./src/helpers/validators.js